import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel } from "bootstrap";

function Crousel() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBanners = async () => {
    try {
      const res = await axios.get(
        "https://api.compliancekare.com/api/Compliance/BannerList"
      );
      setBanners(res.data?.data || []);
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  useEffect(() => {
    // Initialize Bootstrap carousel with auto-play
    const carouselElement = document.getElementById("carouselExampleCaptions");
    if (carouselElement && banners.length > 0) {
      let carousel = Carousel.getInstance(carouselElement);
      if (!carousel) {
        carousel = new Carousel(carouselElement, {
          interval: 10000, // Change slide every 10 seconds
          wrap: true,
          keyboard: true,
          pause: false // Do not pause on hover if we want strict auto sliding, but let's keep it default or set it
        });
      }
      carousel.cycle(); // Start auto-play
    }
  }, [banners]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <h5>Loading banners...</h5>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0">
      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="10000"
      >
        {/* Indicators */}
        <div className="carousel-indicators">
          {banners.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0}
            />
          ))}
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          {banners.length > 0 ? (
            banners.map((banner, index) => {
              const fileUrl = `https://admin.compliancekare.com/BannerImage/${banner.bannerImage}`;
              const isVideo = banner.bannerImage && banner.bannerImage.toLowerCase().endsWith(".mp4");

              return (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                  data-bs-interval="10000"
                >
                  {isVideo ? (
                    <video
                      src={fileUrl}
                      className="d-block w-100 carousel-img"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  ) : (
                    <img
                      src={fileUrl}
                      className="d-block w-100 carousel-img"
                      alt={`banner-${index}`}
                    />
                  )}
                </div>
              );
            })
          ) : (
            <div className="text-center p-5">
              <h5>No banners available</h5>
            </div>
          )}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .carousel-img {
          width: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        .carousel-item {
          overflow: hidden;
        }


        /* Customize Carousel Indicators */
        .carousel-indicators button {
          width: 12px !important;
          height: 12px !important;
          border-radius: 50% !important;
          background-color: #89c764 !important;
          opacity: 0.5;
          border: 2px solid #fff !important;
          margin: 0 5px !important;
          transition: all 0.3s ease !important;
        }

        .carousel-indicators button.active {
          opacity: 1 !important;
          background-color: #446399!important;
          transform: scale(1.2);
        }

        /* Customize Control Buttons */
        .carousel-control-prev,
        .carousel-control-next {
          width: 5%;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        #carouselExampleCaptions:hover .carousel-control-prev,
        #carouselExampleCaptions:hover .carousel-control-next {
          opacity: 0.8;
        }

        .carousel-control-prev-icon,
        .carousel-control-next-icon {
          background-color: rgba(17, 88, 134, 0.7);
          border-radius: 50%;
          padding: 22px;
          background-size: 50%;
        }

        .carousel-control-prev-icon:hover,
        .carousel-control-next-icon:hover {
          background-color: #115886;
        }

        @media (max-width: 1200px) {
          .carousel-img {
            height: 380px;
          }
        }

        @media (max-width: 991px) {
          .carousel-img {
            height: 280px;
          }
        }

        @media (max-width: 768px) {
          .carousel-img {
            height: 200px;
            object-fit: fill;
          }
          .carousel-indicators button {
            width: 8px !important;
            height: 8px !important;
            margin: 0 4px !important;
          }
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            padding: 14px;
            background-size: 45%;
          }
        }

        @media (max-width: 576px) {
          .carousel-img {
            height: 170px;
            object-fit: fill;
          }
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            padding: 11px;
          }
          .carousel-indicators button {
            width: 6px !important;
            height: 6px !important;
            margin: 0 3px !important;
          }
        }

        @media (max-width: 400px) {
          .carousel-img {
            height: 140px;
            object-fit: fill;
          }
          .carousel-control-prev,
          .carousel-control-next {
            width: 8%;
          }
          .carousel-control-prev-icon,
          .carousel-control-next-icon {
            padding: 8px;
          }
        }
      `}} />
    </div>
  );
}

export default Crousel;